import { Box, FormParagraph, IconButton } from '@ksyos/design-system';
import type { OutpatientClinicTaskNoteWithPractitionerAndWithoutTask } from '@common/contexts/support/domain/types/customOutpatientClinicTaskTypes';
import { PatientTaskNoteHeader } from './PatientTaskNoteHeader';

interface IPatientTaskNoteProps {
    note: OutpatientClinicTaskNoteWithPractitionerAndWithoutTask;
    onDelete: () => {};
    onEdit: () => {};
    practitionerCanEditDeleteNotes: boolean;
}

export function PatientTaskNote(props: IPatientTaskNoteProps) {
    return (
        <>
            <Box
                display="flex"
                justifyContent="space-between"
                mb={1}
            >
                <PatientTaskNoteHeader note={props.note} />
                {props.practitionerCanEditDeleteNotes && (
                    <Box
                        display="flex"
                        gap={1}
                    >
                        <IconButton
                            icon="edit-light"
                            onClick={props.onEdit}
                            size="small"
                        />
                        <IconButton
                            icon="delete"
                            onClick={props.onDelete}
                            size="small"
                        />
                    </Box>
                )}
            </Box>
            <FormParagraph>{props.note.text}</FormParagraph>
        </>
    );
}
